
import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Typography,
  Grid,
  Button,
  Pagination,
  Box,
  TextField,
  InputAdornment,
  ModalPreviewComponent,
  FormControl,
  Divider,
  ToggleButton,
} from "@mui/material";
import { RiEyeLine } from "react-icons/ri";
import { AiOutlineDelete, AiOutlineSearch } from "react-icons/ai";
import { RiPencilLine } from "react-icons/ri";

import { toast, ToastContainer } from "react-toastify";
import { Formik, Form } from "formik";
import CustoDropDownRegister from "../CustomDropDown/CustoDropDownRegister";
import { LuCircleCheckBig, LuCircleChevronUp } from "react-icons/lu";
import CustomInputLogin from "../CustomInputLogin/CustomInputLogin";
import { useNavigate } from "react-router-dom";
import { RxCrossCircled } from "react-icons/rx";
import { useDispatch, useSelector } from "react-redux";
import actions from "../../ReduxStore/actions";
import CustomDropdownMui from "../CustomDropDown/CustomDropdown";
import AppraisalPdfGenerator, { generatePDF } from "../../Pages/Employee/MyAppraisal/AppraisalPdfGenerator";
// import ALUMNIREGISTRATIONCONFIRMCommendModal from "../ALUMNIREGISTRATIONCONFIRMCommandModal/ALUMNIREGISTRATIONCONFIRMCommendModal";
import * as Yup from 'yup';

// Yup schema
const validationSchema = Yup.object({
  filterByYear: Yup.string().required('Year is required'),
});


const CustomTable = ({
  tableGeByAppraisalYear,
  tableActivate,
  handleRequestReapply,
  handleaGetDataYearById,
  handleEnterForm, handleActivateAndDeactivate,
  viewDetailsEnterForNotStarted,
  handleDownloadExcel,
  tableExcelDownload,
  tableSearch,
  handleAddNavigate,
  handleConFrimButton,
  handleTableEdit,
  handleDownloadAppraisalPdf,
  // registrationConfirmed,
  OverviewReportsFilter,
  searchByName,
  tableReportSearch,
  tableActions,
  handleALUMNIREGISTRATIONCONFIRMModalOpen,
  tableView,
  tableDelete,
  handleRejectModalOpen,
  tableEdit,
  tableData,
  tableHeadData,
  searchByCourse,
  title,
  handleTableDataDelete,
  handleRequestReapplyReject,
  handleRequestReapplyAccept,
  dynamicLogo
}) => {
  // const rowsPerPage = rowPerPage ? rowPerPage : 5; // Display only 3 rows per page
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const [currentPage, setCurrentPage] = useState(0);

  // const [isALUMNIREGISTRATIONCONFIRMCommandModalOpen, setALUMNIREGISTRATIONCONFIRMCommandModalOpen] = useState(false)

  // const handleALUMNIREGISTRATIONCONFIRMModalOpen = () => {
  //   setALUMNIREGISTRATIONCONFIRMCommandModalOpen(true)
  // }

  // const handleALUMNIREGISTRATIONCONFIRMModalClose = () => {
  //   setALUMNIREGISTRATIONCONFIRMCommandModalOpen(false)
  // }


  // -----------------------modal for operator user registraion is end---------------------

  const handlePageChange = (event, newPage) => {
    setCurrentPage(newPage - 1); // Adjust for 0-based `currentPage`
  };


  // const pageCount = Math.ceil(tableData?.length / rowsPerPage);
  // console.log(pageCount,"pageCount")

  // Paginated data

  const [searchTerm, setSearchTerm] = useState("");
  const [data, setData] = useState(tableData);

  useEffect(() => {
    if (tableData) {
      setData(tableData);
    }
  }, [tableData]);
  // const [currentPage, setCurrentPage] = useState(0);



  const [filters, setFilters] = useState({
    filterByCampusName: "",
    filterByConfirmedStatus: "",
    CampusName: "",
    courseName: "",
    batchyear: "",
    studentName: ""
  });

  const handleSearchChange = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchTerm(value);
    // setCurrentPage(0)
  };






  const filteredData = tableData?.filter((row) => {
    // Check if the row matches the search term
    const matchesSearch = Object.values(row).some((value) =>
      String(value || "").toLowerCase().includes(searchTerm.toLowerCase())
    );


    // Check if the row matches campus filter
    const matchesCampus =
      !OverviewReportsFilter ||
      !filters.filterByCampusName ||
      filters.filterByCampusName === "All Campus" ||
      row.campus?.toLowerCase() === filters.filterByCampusName.toLowerCase();

    // Check if the row matches confirmed status filter
    const matchesConfirmedStatus =
      !OverviewReportsFilter ||
      !filters.filterByConfirmedStatus ||
      filters.filterByConfirmedStatus === "All" ||
      String(row.status)?.toLowerCase() === filters.filterByConfirmedStatus.toLowerCase();

    // Check if the row matches course filter
    const matchesCourse =
      !searchByCourse ||
      !filters.courseName ||
      filters.courseName === "All Course" ||
      row.course?.toLowerCase() === filters.courseName.toLowerCase();

    // Check if the row matches batch filter
    const matchesBatch =
      !searchByCourse ||
      !filters.batchyear ||
      filters.batchyear === "All Batch" ||
      row.batch === filters.batchyear;

    // Check if the row matches student name filter
    const matchesName =
      !filters.studentName ||
      row.firstName?.toLowerCase() === filters.studentName.toLowerCase();

    // Return true if all filter conditions are met
    return (
      matchesSearch &&
      matchesCampus &&
      matchesConfirmedStatus &&
      matchesCourse &&
      matchesBatch &&
      matchesName
    );
  });
  // useEffect(() => {
  //   const totalPages = Math.ceil(filteredData.length / rowsPerPage);
  //   if (currentPage >= totalPages) {
  //     setCurrentPage(0); // Optional fallback if current page is out of bounds
  //   }
  // }, [filteredData, currentPage, rowsPerPage]);


  // Paginate the filtered data


  // if (OverviewReportsFilter) {
  //   setFilters({
  //     filterByCampusName: values.filterByCampusName,
  //     filterByConfirmedStatus: values.filterByConfirmedStatus,
  //   });
  // } else if (searchByCourse) {
  //   setFilters({
  //     CampusName: values.CampusName,
  //     courseName: values.courseName,
  //     batchyear: values.batchyear,
  //   });
  // }



  const pageCount = Math.ceil(filteredData?.length / rowsPerPage);
  console.log(pageCount, "pageCount")


  const paginatedData = filteredData.slice(
    currentPage * rowsPerPage,
    currentPage * rowsPerPage + rowsPerPage
  );
  const keys = Object.keys(paginatedData);

  // Handle delete functionality
  const handleDeleteRow = async (index, id) => {

    if (!id) {
      const updatedData = [...data];
      updatedData.splice(index + currentPage * rowsPerPage, 1);
      setData(updatedData);
    } else {
      handleTableDataDelete(id)


    }
  };

  const handleChange = (event) => {
    setRowsPerPage(event.target.value);
  };

  const customInitialValues = OverviewReportsFilter
    ? {
      filterByCampusName: "",
      filterByConfirmedStatus: "",
    }
    : (searchByCourse) ? {
      CampusName: "",
      courseName: "",
      batchyear: ""
    } : {
      studentName: ""
    }
  const navigate = useNavigate()
  const handleProfileNavigate = (id) => {
    navigate(`/admin/profiledetails/${id}`)

  }

  const dispatch = useDispatch()

  const { getAllAppraisalYears } = useSelector((state) => state?.getAllAppraisalYears);
  console.log(getAllAppraisalYears, "getAllAppraisalYears")

  useEffect(() => {
    const fetchData = async () => {

      const data1 = {
        data: {},
        method: "get",
        apiName: "getAllAppraisalYears"
      };
      const responseData = dispatch(actions.GETALLAPPRAISALYEAR(data1));
      console.log(responseData, "responseData")


    }
    fetchData()

  }, [])

  const yearOptions = getAllAppraisalYears?.data?.map((data, index) => ({

    // id: data?.internship_id,
    value: data?.appraisal_year_id,
    label: data?.appraisal_year
  }));
  console.log(yearOptions, "yearOptions")
  const [questionSectionData, setQuestionSectionData] = useState()

  // const handlePdfGenerateApi = async (employeeId, kra_kpi_id, appraisalyearid) => {
  //   try {
  //     const data1 = {
  //       data: {
  //         employee_id: employeeId,
  //         kra_kpi_id: kra_kpi_id,
  //         appraisal_year_id: appraisalyearid
  //       },
  //       method: "post",
  //       apiName: `getKraKpiAppraisalForm`
  //     };

  //     const responseData = await dispatch(actions.GETKRAKPIAPPRAISALFORM(data1));
  //     const rawData = responseData?.payload?.data;

  //     if (responseData?.payload?.message === "getEmployeeKraKpiByAppraisalForm get successfully.") {
  //       const kraKpiId = `KRAKPI${rawData?.kra_kpi_name?.replace(/\s+/g, "")}${rawData?.appraisal_year?.split("-")[1]}`;

  //       const sections = (
  //         rawData?.appraisal_current_status !== "not started"
  //           ? rawData?.kra_kpi_answers
  //           : rawData?.kra_kpi_questions
  //       ) ?? [];

  //       const mappedSections = sections?.map((kraValue, kraKey) => ({
  //         kraId: `${kraKpiId}_KRA_0${kraKey + 1}`,
  //         kratitle: kraValue?.[`KRA_0${kraKey + 1}`]?.Parameter,
  //         weight: kraValue?.[`KRA_0${kraKey + 1}`]?.Weightage,
  //         TotalAchievement: kraValue?.[`KRA_0${kraKey + 1}`]?.TotalAchievement,
  //         kpis: kraValue?.[`KRA_0${kraKey + 1}`]?.KPIs?.map((kpiValue, kpiKey) => ({
  //           kpiId: `${kraKpiId}_KRA_0${kraKey + 1}_KPI_0${kpiKey + 1}`,
  //           parameter: kpiValue?.[`KRA_0${kraKey + 1}_KPI_0${kpiKey + 1}`]?.Parameter,
  //           weight: String(kpiValue?.[`KRA_0${kraKey + 1}_KPI_0${kpiKey + 1}`]?.Weightage),
  //           achievementPercentage: kpiValue?.[`KRA_0${kraKey + 1}_KPI_0${kpiKey + 1}`]?.achievementPercentage,
  //           Achievement: kpiValue?.[`KRA_0${kraKey + 1}_KPI_0${kpiKey + 1}`]?.Achievement
  //         }))
  //       }));


  //       const employeeDetails = [
  //         { label: 'Employee Name', value: responseData?.payload?.data?.employee_name || "--" },
  //         { label: 'Employee Code', value: responseData?.payload?.data?.employee_code || "--" },
  //         { label: 'Reporting Manager', value: responseData?.payload?.data?.reporting_manager_name || "--" },
  //         { label: 'Reviewer Name', value: responseData?.payload?.data?.reviewer_name || "--" },
  //         { label: 'DOJ', value: responseData?.payload?.data?.date_of_joining || "--" },

  //         { label: 'Department', value: responseData?.payload?.data?.department_name || "--" },
  //         { label: 'Sub Department', value: responseData?.payload?.data?.sub_department_name || "--" },


  //         { label: 'Designation', value: responseData?.payload?.data?.designation_name || "--" },

  //         { label: 'KRA_KPI_ID', value: `KRAKPI${responseData?.payload?.data?.kra_kpi_name?.replace(/\s+/g, "")}${responseData?.payload?.data?.appraisal_year?.split("-")[1]}` || "--" },
  //       ];

  //       const pms_score_show = responseData?.payload?.data?.pms_score_show
  //       // const pms_score_show = true;


  //       const comments = [
  //         { asseseeComments: responseData?.payload?.data?.employee_comment },
  //         { asseseeComments: responseData?.payload?.data?.manager_comment },
  //         { asseseeComments: responseData?.payload?.data?.reviewer_comment },

  //       ]

  //       const rating = [
  //         { pmsScore: responseData?.payload?.data?.reviewer_pms_score },
  //         { reviewer_rating: responseData?.payload?.data?.reviewer_rating }


  //       ]
  //       if (mappedSections.length > 0) {
  //         await AppraisalPdfGenerator({
  //           tableData: mappedSections,
  //           employeeDetails,
  //           comments,
  //           rating,
  //           pms_score_show,
  //           dynamicLogo
  //         });
  //       }


  //     }
  //   } catch (error) {
  //     console.error('PDF generation error:', error);
  //     // You can also show a toast/snackbar here
  //   }
  // };

  const handlePdfGenerateApi = async (employeeId, kra_kpi_id, appraisalyearid) => {
    try {
      const data1 = {
        data: {
          employee_id: employeeId,
          kra_kpi_id: kra_kpi_id,
          appraisal_year_id: appraisalyearid
        },
        method: "post",
        apiName: `getKraKpiAppraisalForm`
      };

      const responseData = await dispatch(actions.GETKRAKPIAPPRAISALFORM(data1));
      const rawData = responseData?.payload?.data;

      if (responseData?.payload?.message === "getEmployeeKraKpiByAppraisalForm get successfully.") {
        const kraKpiId = `KRAKPI${rawData?.kra_kpi_name?.replace(/\s+/g, "")}${rawData?.appraisal_year?.split("-")[1]}`;

        const sections = (
          rawData?.appraisal_current_status !== "not started"
            ? rawData?.kra_kpi_answers
            : rawData?.kra_kpi_questions
        ) ?? [];

        const mappedSections = sections?.map((kraValue, kraKey) => ({
          kraId: `${kraKpiId}_KRA_0${kraKey + 1}`,
          kratitle: kraValue?.[`KRA_0${kraKey + 1}`]?.Parameter,
          weight: kraValue?.[`KRA_0${kraKey + 1}`]?.Weightage,
          TotalAchievement: kraValue?.[`KRA_0${kraKey + 1}`]?.TotalAchievement,
          kpis: kraValue?.[`KRA_0${kraKey + 1}`]?.KPIs?.map((kpiValue, kpiKey) => ({
            kpiId: `${kraKpiId}_KRA_0${kraKey + 1}_KPI_0${kpiKey + 1}`,
            parameter: kpiValue?.[`KRA_0${kraKey + 1}_KPI_0${kpiKey + 1}`]?.Parameter,
            weight: String(kpiValue?.[`KRA_0${kraKey + 1}_KPI_0${kpiKey + 1}`]?.Weightage),
            achievementPercentage: kpiValue?.[`KRA_0${kraKey + 1}_KPI_0${kpiKey + 1}`]?.achievementPercentage,
            Achievement: kpiValue?.[`KRA_0${kraKey + 1}_KPI_0${kpiKey + 1}`]?.Achievement
          }))
        }));

        const employeeDetails = [
          { label: 'Employee Name', value: rawData?.employee_name || "--" },
          { label: 'Employee Code', value: rawData?.employee_code || "--" },
          { label: 'Reporting Manager', value: rawData?.reporting_manager_name || "--" },
          { label: 'Reviewer Name', value: rawData?.reviewer_name || "--" },
          { label: 'DOJ', value: rawData?.date_of_joining || "--" },
          { label: 'Department', value: rawData?.department_name || "--" },
          { label: 'Sub Department', value: rawData?.sub_department_name || "--" },
          { label: 'Designation', value: rawData?.designation_name || "--" },
          { label: 'KRA_KPI_ID', value: kraKpiId || "--" },
        ];

        const pms_score_show = rawData?.pms_score_show;

        const comments = [
          { asseseeComments: rawData?.employee_comment },
          { asseseeComments: rawData?.manager_comment },
          { asseseeComments: rawData?.reviewer_comment }
        ];

        const rating = [
          { pmsScore: rawData?.reviewer_pms_score },
          { reviewer_rating: rawData?.reviewer_rating }
        ];

        if (mappedSections.length > 0) {
          await AppraisalPdfGenerator({
            tableData: mappedSections,
            employeeDetails,
            comments,
            rating,
            pms_score_show,
            dynamicLogo
          });
        }
      }
    } catch (error) {
      console.error('PDF generation error:', error);
      // You can also show a toast/snackbar here
    }
  };

  const { getKraKpiAppraisalForm } = useSelector((state) => state?.getKraKpiAppraisalForm);







  return (
    <>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        {/* <Typography variant="h6" gutterBottom>{title}</Typography> */}
        <Typography variant='subtitle2' sx={{ color: "black", fontSize: "18px" }}>
          {title}
        </Typography>
        {tableSearch && (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              // mt: 1,
              // mb: 1,
            }}
          >
            <TextField
              placeholder="Search..."
              variant="outlined"
              fullWidth
              size="small"
              value={searchTerm}
              onChange={handleSearchChange}
              sx={{
                width: { xs: "100px", md: "150px" },

                borderColor: "black",
                // mb: 2,
                "& .MuiOutlinedInput-notchedOutline": {
                  // border: "1px solid black",
                  // p:"2px",
                  // height: '42px'
                },
                "& .MuiOutlinedInput-root": {
                  borderRadius: "5px",
                  // borderColor: "#C38F51",
                  // border: "2px solid #C38F51",

                  backgroundColor: "white",
                  // backgroundColor: "#f9f9f9",
                  "&:hover fieldset": {
                    borderColor: "black",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "black",
                  },
                },
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <AiOutlineSearch
                      style={{ color: "black", fontSize: "20px" }}
                    />
                  </InputAdornment>
                ),
              }}
            />
          </Box>
        )}
      </Box>
      {/* <Divider /> */}
      <Grid
        container
        xs={12}
        sx={{ background: "white", borderRadius: "5px", mt: 1, px: 2, pb: 2 }}
      >


        <Grid item xs={12} sx={{ width: "100%" }}>
          {tableReportSearch && (
            <>
              <Grid
                // display="flex"
                // justifyContent="space-between"
                // alignItems="center"
                mt={1}
              >

                <Box>
                  <Formik
                    initialValues=
                    {{ filterByYear: "" }}


                    validationSchema={validationSchema}
                    onSubmit={(values) => {

                      handleaGetDataYearById(values?.filterByYear)
                    }}
                  >
                    {({ isSubmitting, values, setFieldValue, resetForm, errors, touched, handleChange, handleBlur }) => (
                      <Form>

                        <Grid container spacing={2}>


                          {OverviewReportsFilter && (
                            <>
                              <Grid item size={{ sm: 5, xs: 12 }}>
                                <CustomDropdownMui
                                  name="filterByYear"
                                  label=""
                                  custPlaceholder="--Select Year of Appraisal--"
                                  // disabled
                                  options={yearOptions}
                                />
                              </Grid>

                            </>
                          )}




                          <Grid item size={{ sm: 3, xs: 12 }}>

                            <Box sx={{ mt: { xs: 1, sm: 0 }, display: "flex", alignItems: "center", justifyContent: "center" }}>
                              <Button
                                // onClick={() => {
                                //   handleAddNavigate()
                                // }}
                                disabled={!values?.filterByYear}
                                type="submit"
                                variant="contained"
                                sx={{
                                  textTransform: "none",
                                  color: "white",
                                  fontSize: "16px",
                                  padding: { xs: "0px 20px", md: "0px 20px" },

                                  boxShadow: "none",
                                  minHeight: "40px",
                                  // borderRadius: "23px",
                                  background: "var(--main-color) 0% 0% no-repeat padding-box",
                                  "&:hover": {
                                    backgroundColor: "var(--main-color)",
                                  },
                                }}
                              >
                                Apply Filter
                              </Button>
                            </Box>
                          </Grid>
                        </Grid>

                      </Form>
                    )}
                  </Formik>
                </Box>
                {tableExcelDownload && (
                  <Button
                    variant='contained'
                    sx={{ mt: 2, mb: 2, background: '#34c38f', textTransform: "none" }}
                    onClick={handleDownloadExcel}
                  >
                    Download as Excel
                  </Button>
                )}


                {/* {tableSearch && (
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      mt: 1,
                      mb: 1,
                    }}
                  >
                    <TextField
                      placeholder="Search..."
                      variant="outlined"
                      fullWidth
                      size="small"
                      value={searchTerm}
                      onChange={handleSearchChange}
                      sx={{
                        width: { xs: "100px", md: "150px" },

                        borderColor: "#C38F51",
                        // mb: 2,
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: "1.5px solid #C38F51",
                          // p:"2px",
                          // height: '42px'
                        },
                        "& .MuiOutlinedInput-root": {
                          borderRadius: "5px",
                          // borderColor: "#C38F51",
                          // border: "2px solid #C38F51",

                          backgroundColor: "white",
                          // backgroundColor: "#f9f9f9",
                          "&:hover fieldset": {
                            borderColor: "#C38F51",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#C38F51",
                          },
                        },
                      }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <AiOutlineSearch
                              style={{ color: "#C38F51", fontSize: "20px" }}
                            />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Box>
                )} */}
              </Grid>
              {/* <Grid>
                <Typography variant="body1" mt={2}>
                  TOTAL RECORDS: {paginatedData?.length}
                </Typography>
              </Grid> */}
            </>
          )}
          <Grid

            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              // mb: 1,
              // mt: 1,
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "start",
                alignItems: "center",
                mb: 1,
                mt: 1,
              }}
            >
              <Typography variant="body1" sx={{ marginRight: 1, color: "#7A7A7A" }}>
                Show
              </Typography>
              <FormControl>
                {/* <label htmlFor="items-per-page">Items</label> */}
                <select
                  style={{ height: "30px", color: "#7A7A7A" }}
                  id="items-per-page"
                  value={rowsPerPage}
                  onChange={handleChange}
                >
                  <option value={5}>5</option>
                  <option value={10}>10</option>
                  <option value={15}>15</option>
                  <option value={20}>20</option>
                </select>
              </FormControl>
              <Typography variant="body1" sx={{ marginLeft: 1, color: "#7A7A7A" }}>
                items
              </Typography>
            </Box>

          </Grid>
          <TableContainer
            component={Paper}
            sx={{ overflowX: "auto", boxShadow: "none" }}
          >
            <Table>
              <TableHead>
                <TableRow
                  sx={{
                    // background: 'var(--table-headbackgroungcolor)',
                    // border: '1px solid #ccc'
                  }}
                >
                  {tableHeadData.map((header, index) => (
                    <TableCell
                      key={index}
                      sx={{
                        // border: '1px solid #ccc',
                        color: "black",
                        padding: "8px",
                        fontSize: "14px",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                      }}
                    >
                      <Typography variant="subtitle2" sx={{ fontSize: "15px" }}>
                        {header}
                      </Typography>
                    </TableCell>
                  ))}
                  {searchByName && (
                    <TableCell
                      ariant="subtitle2"
                      sx={{ color: "white", padding: "8px", fontSize: "15px" }}
                    >
                      View
                    </TableCell>
                  )}
                </TableRow>
              </TableHead>
              <TableBody>
                {paginatedData.map((row, index) => (


                  <TableRow
                    key={index}
                    sx={{
                      backgroundColor: index % 2 === 0 ? "rgb(183 193 201 / 12%)" : "#FFFFFF",
                    }}
                  >
                    <TableCell
                      sx={{
                        // border: '1px solid #ccc',

                        // borderBottomColor: "#C38F51",
                      }}
                    >
                      <Typography variant="body1" sx={{ color: "black" }}>
                        {currentPage * rowsPerPage + index + 1}
                      </Typography>
                    </TableCell>
                    {/* {row[key] === "photo" && (
                      <TableCell
                        sx={{
                          border: '1px solid #ccc',

                          // borderBottomColor: "#C38F51",
                        }}
                      >
                        <Box
                          component="img"
                          src={row.photo}
                          sx={{ height: 50, width: 50 }}
                        />
                      </TableCell>
                    )} */}
                    {/* {Object.keys(row).map(
                      (key) =>
                        key !== "id" && key !== "photo" && key !== "status" && (
                          <TableCell
                            key={key}
                            sx={{
                              color: "#707070",
                              fontSize: "13px",
                              whiteSpace: "nowrap",
                              textOverflow: "ellipsis",
                              borderBottomColor: "#C38F51",
                            }}
                          >
                            <Typography
                              variant="body1"
                              sx={{
                                fontSize: "14px",
                                color: "black"

                              }}
                            >

                              {row[key]}
                            </Typography>
                          </TableCell>
                        )
                        
                    )} */}
                    {Object.keys(row).map((key) => {
                      if (key === "employeeId") return null;
                      if (key === "activeStatus") return null;
                      if (key === "kra_kpi_question_id") return null;
                      if (key === "appraisalyearid") return null;
                      if (key === "kra_kpi_id") return null;
                      if (key === "kra_kpi_answer_id") return null;
                      if (key === "id") return null;
                      // if (key === "reviewer_reject_comment") return null;








                      if (key === "photo") {
                        return (
                          <TableCell
                            key={key}
                            sx={{
                              // border: '1px solid #ccc',
                            }}
                          >
                            <Box
                              component="img"
                              src={row.photo}
                              sx={{ height: 50, width: 50 }}
                            />
                          </TableCell>
                        );
                      }


                      if (key === "status") {
                        return (
                          <TableCell
                            key={key}
                            sx={{
                              // border: '1px solid #ccc',

                              whiteSpace: "nowrap",
                              textOverflow: "ellipsis",
                              // borderBottomColor: "#C38F51",
                            }}
                          >
                            {row[key] === 3 ? (
                              <Box
                              // sx={{textAlign:"center"}}
                              >
                                <LuCircleCheckBig style={{ color: "green", fontSize: "35px" }} />
                              </Box>
                            ) : row[key] === 2 ? (
                              <>
                                <Button
                                  onClick={() => {
                                    handleRejectModalOpen(row.id)

                                  }}
                                  // type="submit"
                                  variant="contained"
                                  sx={{
                                    textTransform: "none",
                                    color: "white",
                                    fontSize: "14px",
                                    padding: { xs: "0px 10px", md: "0px 10px" },
                                    mr: 2,

                                    boxShadow: "none",
                                    minHeight: "20px",
                                    // borderRadius: "23px",
                                    background: "red 0% 0% no-repeat padding-box",
                                    "&:hover": {
                                      backgroundColor: "var(--main-color)",
                                    },
                                  }}
                                >
                                  Reject
                                </Button>
                                <Button
                                  onClick={() => {
                                    handleConFrimButton(row.id)
                                  }}
                                  // type="submit"
                                  variant="contained"
                                  sx={{
                                    textTransform: "none",
                                    color: "white",
                                    fontSize: "14px",
                                    padding: { xs: "0px 10px", md: "0px 10px" },

                                    boxShadow: "none",
                                    minHeight: "20px",
                                    // borderRadius: "23px",
                                    background: "var(--main-color) 0% 0% no-repeat padding-box",
                                    "&:hover": {
                                      backgroundColor: "var(--main-color)",
                                    },
                                  }}
                                >
                                  Confirm
                                </Button>
                              </>
                            ) : (<Box
                            // sx={{textAlign:"center"}}
                            >
                              <RxCrossCircled style={{ color: "red", fontSize: "35px" }} />
                            </Box>)}
                          </TableCell>
                        );
                      }
                      if (row[key] === "Self Evaluation Completed" || row[key] === "PMS Closed") {
                        return (
                          <TableCell key={`${key}-edit`}
                            sx={{
                              // border: '1px solid #ccc',

                              whiteSpace: "nowrap",
                              textOverflow: "ellipsis",
                              // borderBottomColor: "#C38F51",
                            }}
                          >
                            <Button
                              onClick={() => handleAddNavigate(row?.id)}
                              variant="contained"
                              sx={{
                                textTransform: "none",
                                fontSize: "14px",
                                padding: { xs: "5px 20px", md: "5px 10px" },
                                mr: 1,
                                boxShadow: "none",
                                minHeight: "20px",
                                color: "var(--main-color)",
                                backgroundColor: "rgb(40 126 185 / 10%)",
                              }}
                            >
                              {row[key]}
                            </Button>
                          </TableCell>
                        );
                      }
                      if (key === "appraisal_current_status") {
                        return (
                          <TableCell
                            sx={{
                              // border: '1px solid #ccc',

                              whiteSpace: "nowrap",
                              textOverflow: "ellipsis",
                              // borderBottomColor: "#C38F51",
                            }}>
                            <Typography variant="body1" sx={{
                              color: "white",
                              p: 2,
                              py: 1,
                              borderRadius: "5px",
                              background: row[key][0] === "pending" ?
                                "#ec2c2d" : row[key][0] === "employee evaluation completed" && row[key][1] === "--" ?
                                  "#f1b44c" : row[key][0] === "manager evaluation completed" ?
                                    "var(--main-color)" : row[key][0] === "reviewer evaluation completed" ?
                                      "#34c38f" : row[key][1] === "--" ? "gray" : "#ec2c2d"

                            }}>
                              {row[key][0] === "pending" ?
                                "Resubmitted the form." : row[key][1] === "--" || row[key][0] === "manager evaluation completed" ?
                                  row[key][0]?.charAt(0).toUpperCase() + row[key][0]?.slice(1) : "Reviewer Reject the form"}
                            </Typography>
                          </TableCell>

                        )
                      }

                      if (key === "viewDetails") {

                        if (viewDetailsEnterForNotStarted === "Manager" && (row?.appraisal_current_status?.[0] === "not started" || row?.appraisal_current_status?.[0] === "pending")) {
                          return (
                            <TableCell
                              sx={{
                                // border: '1px solid #ccc',

                                whiteSpace: "nowrap",
                                textOverflow: "ellipsis",
                                // borderBottomColor: "#C38F51",
                              }}>
                              <Button
                                // onClick={() => {
                                //   handleEnterForm(row?.kra_kpi_id, row?.employeeid, row?.appraisalyearid)
                                // }
                                // }
                                variant="contained"
                                sx={{
                                  textTransform: "none",
                                  fontSize: "14px",
                                  padding: { xs: "5px 20px", md: "5px 10px" },
                                  mr: 1,
                                  boxShadow: "none",
                                  minHeight: "20px",
                                  color: "var(--main-color)",
                                  backgroundColor: "rgb(40 126 185 / 10%)",
                                  // color:"white"
                                }}
                              >
                                Wait for employee evaluation
                              </Button>
                            </TableCell>
                          )

                        }
                        else if (viewDetailsEnterForNotStarted === "reviewer" && (row?.appraisal_current_status[0] === "employee evaluation completed" || row?.appraisal_current_status[0] === "not started" || row?.appraisal_current_status[0] === "pending")) {
                          return (
                            <TableCell
                              sx={{
                                // border: '1px solid #ccc',

                                whiteSpace: "nowrap",
                                textOverflow: "ellipsis",
                                // borderBottomColor: "#C38F51",
                              }}>
                              <Button
                                // onClick={() => {
                                //   handleEnterForm(row?.kra_kpi_id, row?.employeeid, row?.appraisalyearid)
                                // }
                                // }
                                variant="contained"
                                sx={{
                                  textTransform: "none",
                                  fontSize: "14px",
                                  padding: { xs: "5px 20px", md: "5px 10px" },
                                  mr: 1,
                                  boxShadow: "none",
                                  minHeight: "20px",
                                  color: "var(--main-color)",
                                  backgroundColor: "rgb(40 126 185 / 10%)",
                                  // color:"white"
                                }}
                              >
                                Wait for manager evaluation
                              </Button>
                            </TableCell>
                          )

                        }
                        else {
                          return (
                            <TableCell key={`${key}-edit`}
                              sx={{
                                // border: '1px solid #ccc',

                                whiteSpace: "nowrap",
                                textOverflow: "ellipsis",
                                // borderBottomColor: "#C38F51",
                              }}>
                              <Button
                                onClick={() => {
                                  handleEnterForm(row?.kra_kpi_id, row?.employeeId, row?.appraisalyearid)
                                }
                                }
                                variant="contained"
                                sx={{
                                  textTransform: "none",
                                  fontSize: "14px",
                                  padding: { xs: "5px 20px", md: "5px 10px" },
                                  mr: 1,
                                  boxShadow: "none",
                                  minHeight: "20px",
                                  color: "var(--main-color)",
                                  backgroundColor: "rgb(40 126 185 / 10%)",
                                }}
                              >
                                Enter
                              </Button>
                            </TableCell>
                          );
                        }

                      }
                      if (key === "reAppeal") {

                        if (row[key][0] === "employee evaluation completed" && row[key][1] === "none"
                          // && row[key] === "Self Evaluation Completed"
                        ) {
                          return (
                            <TableCell key={`${key}-edit`}
                              sx={{
                                // border: '1px solid #ccc',

                                whiteSpace: "nowrap",
                                textOverflow: "ellipsis",
                                // borderBottomColor: "#C38F51",
                              }}>
                              <Button
                                onClick={() => handleRequestReapply(row?.kra_kpi_answer_id)}
                                variant="contained"
                                sx={{
                                  textTransform: "none",
                                  fontSize: "14px",
                                  padding: { xs: "5px 20px", md: "5px 10px" },
                                  mr: 1,
                                  boxShadow: "none",
                                  minHeight: "20px",
                                  color: "var(--main-color)",
                                  backgroundColor: "rgb(40 126 185 / 10%)",
                                }}
                              >
                                Request for reapply
                              </Button>
                            </TableCell>
                          );
                        }
                        else {
                          return (
                            <TableCell key={`${key}-edit`}
                              sx={{
                                // border: '1px solid #ccc',

                                whiteSpace: "nowrap",
                                textOverflow: "ellipsis",
                                textAlign: "start"
                                // borderBottomColor: "#C38F51",
                              }}>
                              <Typography variant="subtitle1">
                                {/* {row[key][1] || "--"} */}
                                {row[key][1] ? row[key][1]?.charAt(0).toUpperCase() + row[key][1]?.slice(1) : "--"}

                              </Typography>
                            </TableCell>

                          )
                        }

                      }

                      if (row[key] === "downloadForm"
                        // && row[key] === "Self Evaluation Completed"
                      ) {
                        return (
                          <TableCell key={`${key}-edit`}
                            sx={{
                              // border: '1px solid #ccc',

                              whiteSpace: "nowrap",
                              textOverflow: "ellipsis",
                              // borderBottomColor: "#C38F51",
                            }}>
                            {/* <PDFDownloadLink
                              document={<MyDocument />}
                              fileName="performance_report.pdf"
                            >
                              {({ loading }) => (
                                // <Button variant="contained" disabled={loading}>
                                //   {loading ? 'Loading document...' : 'Download PDF'}
                                // </Button>
 */}

                            <Button
                              onClick={() => {
                                handlePdfGenerateApi(
                                  row?.employeeId,
                                  row?.kra_kpi_id,
                                  row?.appraisalyearid,
                                )
                              }}
                              variant="contained"
                              sx={{
                                textTransform: "none",
                                fontSize: "14px",
                                padding: { xs: "5px 20px", md: "5px 10px" },
                                mr: 1,
                                boxShadow: "none",
                                minHeight: "20px",
                                color: "var(--main-color)",
                                backgroundColor: "rgb(40 126 185 / 10%)",
                              }}
                            >
                              Download Form
                              {/* <PDFContainer /> */}
                            </Button>
                            {/* )}
                            </PDFDownloadLink> */}
                          </TableCell>
                        );
                      }
                      if (row[key] === "downloadAppraisalletter"
                        // && row[key] === "Self Evaluation Completed"\
                      ) {
                        if (row[key] === "downloadAppraisalletter") {
                          return (
                            <TableCell key={`${key}-edit`}
                              sx={{
                                // border: '1px solid #ccc',

                                whiteSpace: "nowrap",
                                textOverflow: "ellipsis",
                                // borderBottomColor: "#C38F51",
                              }}>


                              <Button
                                onClick={() => {
                                  handleDownloadAppraisalPdf(
                                    row?.appraisal_year, row.employee_code
                                  )
                                }}
                                variant="contained"
                                sx={{
                                  textTransform: "none",
                                  fontSize: "14px",
                                  padding: { xs: "5px 20px", md: "5px 10px" },
                                  mr: 1,
                                  boxShadow: "none",
                                  minHeight: "20px",
                                  color: "var(--main-color)",
                                  backgroundColor: "rgb(40 126 185 / 10%)",
                                }}
                              >
                                Download Appraisal Letter
                              </Button>
                              {/* )}
                            </PDFDownloadLink> */}
                            </TableCell>
                          );
                        } else {
                          <TableCell>
                            <Typography variant="body1">--</Typography>
                          </TableCell>

                        }
                      }


                      if (key === "pmsScoreEnable"
                        // && row[key] === "Self Evaluation Completed"\
                      ) {
                        if (row[key] === "pmsScoreEnable") {
                          return (
                            <TableCell key={`${key}-edit`}
                              sx={{
                                // border: '1px solid #ccc',

                                whiteSpace: "nowrap",
                                textOverflow: "ellipsis",
                                // borderBottomColor: "#C38F51",
                              }}>


                              <ToggleButton
                                value="check"
                                selected={row?.toggleSelected}
                                // onChange={() => handleToggle(row)}
                                sx={{
                                  textTransform: "none",
                                  fontSize: "14px",
                                  padding: { xs: "5px 20px", md: "5px 10px" },
                                  mr: 1,
                                  boxShadow: "none",
                                  minHeight: "20px",
                                  color: "var(--main-color)",
                                  backgroundColor: row?.toggleSelected
                                    ? "rgb(40 126 185 / 20%)"
                                    : "rgb(40 126 185 / 10%)",
                                }}
                              >
                                {row?.toggleSelected ? "Enabled" : "Disabled"}
                              </ToggleButton>
                              {/* )}
                            </PDFDownloadLink> */}
                            </TableCell>
                          );

                        }
                      }



                      if (key === "appraisal_reapply_status"
                        // && row[key] === "Self Evaluation Completed"
                      ) {
                        if (row[key] === "requested") {
                          return (
                            <TableCell key={`${key}-edit`}
                              sx={{
                                // border: '1px solid #ccc',

                                whiteSpace: "nowrap",
                                textOverflow: "ellipsis",
                                // borderBottomColor: "#C38F51",
                              }}>


                              <Button
                                onClick={() => handleRequestReapplyAccept(row?.kra_kpi_answer_id)}

                                // onClick={() => {
                                //   appraisalPdfGenerator({
                                //     employeeId: row?.employeeId,
                                //     kra_kpi_id: row?.kra_kpi_id,
                                //     appraisalyearid: row?.appraisalyearid,
                                //   })
                                // }}
                                variant="contained"
                                sx={{
                                  textTransform: "none",
                                  fontSize: "14px",
                                  padding: { xs: "5px 20px", md: "5px 10px" },
                                  mr: 1,
                                  boxShadow: "none",
                                  minHeight: "20px",
                                  color: "var(--main-color)",
                                  backgroundColor: "rgb(40 126 185 / 10%)",
                                }}
                              >
                                Accept
                              </Button>
                              <Button
                                onClick={() => handleRequestReapplyReject(row?.kra_kpi_answer_id)}

                                // onClick={() => {
                                //   appraisalPdfGenerator({
                                //     employeeId: row?.employeeId,
                                //     kra_kpi_id: row?.kra_kpi_id,
                                //     appraisalyearid: row?.appraisalyearid,
                                //   })
                                // }}
                                variant="contained"
                                sx={{
                                  textTransform: "none",
                                  fontSize: "14px",
                                  padding: { xs: "5px 20px", md: "5px 10px" },
                                  mr: 1,
                                  boxShadow: "none",
                                  minHeight: "20px",

                                  color: "red",
                                  backgroundColor: "rgb(213 25 25 / 10%)",
                                }}
                              >
                                Reject
                              </Button>
                              {/* )}
                            </PDFDownloadLink> */}
                            </TableCell>
                          );
                        }
                        else {
                          <TableCell>
                            <Typography variant="body1">--</Typography>
                          </TableCell>

                        }

                      }



                      // default rendering for other keys
                      return (
                        <TableCell
                          key={key}
                          sx={{
                            // border: '1px solid #ccc',

                            color: "#707070",
                            fontSize: "13px",
                            whiteSpace: "nowrap",
                            textOverflow: "ellipsis",
                            // borderBottomColor: "#C38F51",
                          }}
                        >
                          <Typography
                            variant="body1"
                            sx={{
                              fontSize: "14px",
                              color: "black",
                            }}
                          >
                            {row[key]}
                          </Typography>
                        </TableCell>
                      );


                    }

                    )}


                    {searchByName && (
                      <TableCell
                        sx={{
                          whiteSpace: "nowrap",
                          textOverflow: "ellipsis",
                          // border: "1px solid #ccc",
                          // borderBottomColor: "#C38F51",
                        }}
                      >
                        <Button variant="none" onClick={() => {
                          handleProfileNavigate(row.id)
                        }
                        }>
                          <Typography variant="body1"
                            color="var(--main-color)"

                          >
                            View More
                          </Typography>
                        </Button>
                      </TableCell>
                    )}


                    {tableActions && (
                      <TableCell
                        sx={{
                          whiteSpace: "nowrap",
                          textOverflow: "ellipsis",
                          // borderBottomColor: "#C38F51",
                          // border: '1px solid #ccc',

                        }}
                      >
                        {tableEdit && (
                          <Button
                            onClick={() => {
                              handleTableEdit(row?.employeeId || row?.kra_kpi_question_id || row?.id)
                            }}
                            variant="contained"
                            sx={{

                              textTransform: "none",
                              // borderColor: "#ACB0BF",
                              fontSize: "14px",
                              padding: { xs: "5px 20px", md: "5px 10px" },
                              mr: 1,


                              boxShadow: "none",
                              minHeight: "20px",
                              color: "var(--main-color)",
                              backgroundColor: "rgb(40 126 185 / 10%)",
                              // // background: "var(--main-color) 0% 0% no-repeat padding-box",
                              // "&:hover": {
                              //   backgroundColor: "var(--main-color)",
                              // },
                            }}

                          >
                            Edit
                          </Button>
                        )}
                        {tableView && (
                          <RiEyeLine

                            style={{
                              fontSize: "16px",
                              marginRight: "10px",
                              color: "#ACB0BF",
                              cursor: "pointer",
                            }}
                          />
                        )}
                        {tableDelete && (
                          <AiOutlineDelete
                            // onClick={() => handleDeleteRow(row, row.user_id || row.plan_id || row.section_id)}
                            style={{
                              fontSize: "16px",
                              color: "#ACB0BF",
                              cursor: "pointer",
                            }}
                          />
                        )}
                        {tableActivate && (
                          <Button
                            onClick={() => {
                              handleActivateAndDeactivate(row?.activeStatus, row?.employeeId)
                            }}
                            variant="contained"
                            sx={{

                              textTransform: "none",
                              // borderColor: "#ACB0BF",
                              fontSize: "14px",
                              padding: { xs: "5px 20px", md: "5px 10px" },

                              boxShadow: "none",
                              minHeight: "20px",
                              color: "var(--main-color)",
                              backgroundColor: "rgb(213 25 25 / 10%)",
                              color: "red"
                              // // background: "var(--main-color) 0% 0% no-repeat padding-box",
                              // "&:hover": {
                              //   backgroundColor: "var(--main-color)",
                              // },
                            }}
                          // startIcon={
                          //   <RiPencilLine

                          //     style={{
                          //       fontSize: "16px",
                          //       color: "#ACB0BF",
                          //       // marginRight: "10px",
                          //       cursor: "pointer",
                          //     }}
                          //   />

                          // }
                          >
                            {row?.activeStatus === true ? "Activate" : "Deactivate"}
                          </Button>
                        )}


                        {tableGeByAppraisalYear && (
                          <Button
                            onClick={() => {
                              handleTableEdit(row?.appraisal_year)
                            }}
                            variant="contained"
                            sx={{

                              textTransform: "none",
                              // borderColor: "#ACB0BF",
                              fontSize: "14px",
                              padding: { xs: "5px 20px", md: "5px 10px" },
                              mr: 1,


                              boxShadow: "none",
                              minHeight: "20px",
                              color: "var(--main-color)",
                              backgroundColor: "rgb(40 126 185 / 10%)",
                              // // background: "var(--main-color) 0% 0% no-repeat padding-box",
                              // "&:hover": {
                              //   backgroundColor: "var(--main-color)",
                              // },
                            }}

                          >
                            Edit By Appraisal Year
                          </Button>
                        )}

                        {!tableEdit && !tableView && !tableDelete && !tableGeByAppraisalYear && "--"}

                      </TableCell>
                    )}
                    {/* {isRejectCommandModalOpen && (
                      <RejectCommendModal
                        id={row.id}
                        open={isRejectCommandModalOpen}
                        onClose={handleRejectModalClose}
                      />
                    )} */}
                  </TableRow>

                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <Box sx={{ display: "flex", justifyContent: "end" }}>
            <Pagination
              count={pageCount}
              page={currentPage + 1}
              onChange={handlePageChange}
              siblingCount={1}
              boundaryCount={1}
              shape="rounded"
              sx={{
                mt: 2,
                "& .MuiPaginationItem-root": {
                  color: "var(--main-color)", // Default text color
                  border: "1px solid var(--main-color)", // Default border color
                  "&:hover": {
                    backgroundColor: "transparent", // Removes hover background color
                  },
                  "&.Mui-selected": {
                    backgroundColor: "var(--main-color)", // Selected background color
                    color: "white", // Selected text color
                    border: "none", // Remove border for selected items
                    "&:hover": {
                      backgroundColor: "var(--main-color)", // Ensure hover does not change selected color
                    },
                  },
                },
              }}
            />
          </Box>

        </Grid>
      </Grid >
    </>
  );
};

export default CustomTable;
